import { optionSchema } from '@/common/schemas/option.schema'
import { z } from 'zod'

export const updatePoliticsFinancialSchema = z.object({
  payment_advance_daily_interest: z.string({ message: 'Campo obrigatório' }).min(1, 'Campo obrigatório'),
  payment_advance_min_total_to_be_paid: z.string({ message: 'Campo obrigatório' }).min(1, 'Campo obrigatório'),
  capture_methods: z.array(optionSchema),
  bank_account_information: z.object({
    account: z.string({ message: 'Campo Conta é obrigatório' }).trim().min(1, 'Campo Conta é obrigatório'),
    agency: z.string({ message: 'Campo Agência é obrigatório' }).trim().min(1, 'Campo Agência é obrigatório'),
    bank_institution: optionSchema,
    payee_name: z.string({ message: 'Campo Favorecido é obrigatório' }).trim().min(1, 'Campo Favorecido é obrigatório'),
  }),
})

export type UpdatePoliticsFinancialValidationSchema = z.infer<typeof updatePoliticsFinancialSchema>
